export default "__VITE_ASSET__Bs_Zb_Xy__"